import React from 'react';
import PropTypes from 'prop-types';

import { StyledBoxApps, StyledTitleApps, StyledIconArrow } from './style';
import { Apps } from '../Apps';
import { Back } from '../../../../assets/images/index';

/** HOC */
import withOutsideClick from '../../views/Common/ClickOutside';

const MyApps = ({ className, onClickBack, show }) => (
  <StyledBoxApps className={className}>
    <StyledTitleApps>
      <StyledIconArrow
        onClick={onClickBack}
        size="xs"
        color="light"
        svg={Back}
      />{' '}
      Accesos directos
    </StyledTitleApps>
    <Apps className="MenuBurguer" onClickBack={onClickBack} show={show} />
  </StyledBoxApps>
);

MyApps.propTypes = {
  className: PropTypes.string,
  onClickBack: PropTypes.func
};

export default withOutsideClick(MyApps);
